export const modals = {
  'm-auth': {
    component: () => import( /* webpackChunkName: "modals" */ './m-auth.vue' ),
    meta: {
      fullscreen: true,
      bg: true,
    },
  },
  'm-preview': {
    component: null,
    meta: {
      fullscreen: true,
      bg: true,
    },
  },
  'm-confirm': {
    component: () => import( /* webpackChunkName: "modals" */ './m-confirm.vue' ),
    meta: {},
  },
  'm-upload': {
    component: () => import( /* webpackChunkName: "modals" */ './m-upload.vue' ),
    meta: {}
  },
  'm-select-media': {
    component: () => import( /* webpackChunkName: "modals" */ './m-select-media.vue' ),
    meta: {
      fullscreen: true,
    }
  },
  'm-tag': {
    component: () => import( /* webpackChunkName: "modals" */ './m-tag.vue' ),
    meta: {}
  },
  'm-notice': {
    component: () => import( /* webpackChunkName: "modals" */ './m-notice.vue' ),
    meta: {
      fullscreen: true,
      centered: true,
      bg: true,
    },
  },
}

const components = {}
for ( const k of Object.keys( modals )) {
  components[k] = modals[k].component
}

export {
  components
}
